import React from 'react'

export default function CheckTikIcon({ ...props }) {
    return (
        <svg {...props} viewBox="0 0 16 16" fill="none">
            <path d="M2.75 7.62L6.5 11.37L13.25 4.62" stroke="currentcolor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}